// src/components/Sidebar.tsx

import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Avatar,
  Divider,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PaymentsIcon from '@mui/icons-material/Payments';
import CalculateIcon from '@mui/icons-material/Calculate';
import LogoutIcon from '@mui/icons-material/Logout';

import { useNavigate, useLocation } from 'react-router-dom';

interface Props {
  onSelect: (label: string) => void;
}

export default function Sidebar({ onSelect }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { label: 'Dashboard', icon: '/assets/icons/dashboard/chart.png', path: '/dashboard' },
    // { label: 'Tracking', icon: '/assets/icons/dashboard/trazability.png', path: '/cocina' },
    { label: 'Órdenes', icon: '/assets/icons/dashboard/shopping-bag.png', path: '/ordenes' },
    // { label: 'Asignación Motorizado', icon: '/assets/icons/dashboard/package.png', path: '/asignacion' },
    { label: 'Conductores', icon: '/assets/icons/dashboard/users-round.png', path: '/conductores' },
    
    // { label: 'Productos', icon: '/assets/icons/dashboard/cooking-pot.png', path: '/productos' },
    // { label: 'Zonas de entrega', icon: '/assets/icons/dashboard/trazability.png', path: '/zonas-entrega' },
    // { label: 'Programación', icon: '/assets/icons/dashboard/calendar-check.png', path: '/programacion' },
    // { label: 'Cupones', icon: '/assets/icons/dashboard/ticket-percent.png', path: '/cupones' },
    // { label: 'Actualizar pedido', icon: '/assets/icons/dashboard/settings.png', path: '/ajustes' }
  ];


  return (
    <Box
      sx={{
        
        width: 240,
        minWidth: 240,
        height: '100vh',
        backgroundColor: '#f3f3f3',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflow: 'hidden', // 👈 CLAVE
      }}
    >
      {/* Parte superior */}
      {/* Parte superior */}
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        <List sx={{ px: '1em' }}>
          {menuItems.map((item) => (
            <ListItem
              key={item.label}
              button
              onClick={() => {
                onSelect(item.label);
                navigate(item.path);
              }}
              sx={{
                gap: 1,
                px: 2,
                borderRadius: '10px',
                backgroundColor:
                  location.pathname === item.path ? '#dfdfdf' : 'transparent',
                '&:hover': { backgroundColor: '#eaeaea' },
              }}
            >
              <ListItemIcon sx={{ minWidth: 30 }}>
                <img
                  src={item.icon}
                  alt={item.label}
                  style={{
                    width: 18,
                    height: 18,
                    objectFit: 'contain',
                    opacity: location.pathname === item.path ? 1 : 0.7,
                  }}
                />
              </ListItemIcon>

              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: '12px',
                  fontWeight: 'normal',
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>


      

    </Box>
  );
}
